var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"modal-title",attrs:{"id":"contactModalLabel"},domProps:{"textContent":_vm._s(_vm.headingText)}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-371fb9d2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/AAA_TO_REFACTOR/Bootstrap/BootstrapVersionFixers/ModalHeading/ModalTitle.vue
// module id = 734
// module chunks = 0 1